import ks from "../ReUsableTS/kBrowserShared";
import { kStyles } from "./kStyles";
import type { kStyleClass } from "./kStyles";
import type { kEditableTable } from "./kEditableTable";
import type { kEditableTableRow } from "./kEditableTableRow";
import type { kEditableColumn } from "./kEditableColumn";

// kEditableTableHeading, moved out of kEditableTable.ts (size split, 2026-10-20); re-exported from kEditableTable.ts.

export class kEditableTableHeading{
    public Title:string = "";
    public HeaderCell:HTMLTableCellElement|null = null;
    public SortButton:HTMLSpanElement|null = null;
    public SortedAscending:boolean = true;
    public Sorted:boolean = false;
    public ParentTable:kEditableTable|null = null;
    public ColumnIndex:number = 0;
    public Sortable:boolean = true;
    // The funnel affordance on this header (built by the grid in slice 2). Null
    // until the grid opts the column into per-column filtering.
    public FilterIcon:HTMLSpanElement|null = null;

    // Highlights the funnel when the column carries an active filter (feature
    // #7). No-op until FilterIcon exists.
    public SetFilterActive = (Active:boolean): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if(this.FilterIcon === null){ return; }
            // Visibility is governed by CSS (hidden by default, shown on header
            // hover, always shown when .kFilterActive). Toggle only the class so
            // an inline opacity never overrides the hover/active rules.
            if(Active === true){
                this.FilterIcon.classList.add("kFilterActive");
                // aria-pressed conveys the active state to assistive tech, and a
                // CSS badge (.kFilterActive::after) conveys it without relying on
                // colour alone (WCAG 1.4.1).
                this.FilterIcon.setAttribute("aria-pressed", "true");
            }else{
                this.FilterIcon.classList.remove("kFilterActive");
                this.FilterIcon.setAttribute("aria-pressed", "false");
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableHeading.SetFilterActive");
        }
    }
    public RowBeingRightClick:kEditableTableRow|null = null;
    public RightClickColumn:kEditableTableHeading|null = null;
    constructor(Title:string,Sortable:boolean = true,Icon:HTMLImageElement|null|undefined){
        this.Title = Title;
        this.HeaderCell = document.createElement("th");
        // A real column header: scope="col" is what associates every cell in the
        // column with this heading for a screen reader reading cell-by-cell.
        // Added 2026-07-30 — the <th> was already correct, only the association
        // was missing.
        this.HeaderCell.setAttribute("scope", "col");
        if(Icon){
            const IconStyle:kStyleClass = kStyles.AddStyle("kEdTblHeaderIcon");
            if(IconStyle.Saved === false){
                IconStyle.Style.position = "relative";
                IconStyle.Style.top = "1px";
            }
            IconStyle.Apply(Icon);
            this.HeaderCell.appendChild(Icon);
            if(ks.Nz(Title)!==""){
                const HeaderLabel:HTMLSpanElement = document.createElement("span");
                HeaderLabel.textContent = Title;

                const LabelStyle:kStyleClass = kStyles.AddStyle("kEdTblHeaderLabelWithIcon");
                LabelStyle.Style.marginLeft = "2px";;
                LabelStyle.Apply(HeaderLabel);
                
                this.HeaderCell.appendChild(HeaderLabel);
            }
        }else{
            this.HeaderCell.textContent = Title;
        }
        this.HeaderCell.addEventListener("click",this.HeadingClick);
        this.Sortable = Sortable;
        if(this.Sortable){
            this.HeaderCell.addEventListener("contextmenu",this.HeaderRightClick);
            this.HeaderCell.addEventListener("dblclick",this.ColumnDblClick);
            this.SortButton = document.createElement("span");
            //this.SortButton.style.cursor = "pointer";
            this.SortButton.style.cssFloat = "right";
            this.SortButton.style.paddingRight = "4px";
            this.SetUnsorted();
            // this.SortButton.addEventListener("click",this.SortClick);
            this.HeaderCell.appendChild(this.SortButton);

        } 
    }
    public HeadingClick = (Event:MouseEvent): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            let CurrCol:kEditableColumn;
            if(this.ParentTable){
                CurrCol = this.ParentTable.Columns.Items[this.ColumnIndex]
                this.ParentTable.Selection.SetSingleColSelected(CurrCol);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableHeading.HeadingClick");
            return;
        }
    }
    public HeaderRightClick = (Event:MouseEvent): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if(this.ParentTable && this.ParentTable.ColContextMenu){
                this.ParentTable.RightClickColumn = this;
                this.ParentTable.ColContextMenu.ShowMenu(Event);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableHeading.HeaderRightClick");
            return;
        }
    }
    public ColumnDblClick = (Event:MouseEvent): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if(this.ParentTable){
                this.ParentTable.SortByColumn(this.ColumnIndex);
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableHeading.ColumnDblClick");
            return;
        }
    }
    // Reflects the column's CURRENT sort state to assistive tech. Only a sortable
    // header carries aria-sort at all — the attribute on a non-sortable column
    // would wrongly advertise it as sortable. Added 2026-07-30; the visible
    // arrow glyph already conveyed this state sightedly, nothing conveyed it
    // otherwise.
    public SetAriaSort = (State: string): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if (this.HeaderCell === null) { return; }
            if (this.Sortable === false) { return; }
            this.HeaderCell.setAttribute("aria-sort", State);
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableHeading.SetAriaSort");
        }
    }
    public SetUnsorted = (): void => {
        if (ks.KErrorMode === true) { return; }
        try {
            if(this.SortButton){
                //this.SortButton.innerHTML = "&#8645;";
                this.SortButton.innerText ="";
                this.SortedAscending = false;
                this.Sorted =false;
                this.SortButton.style.fontWeight = "normal";
                this.SortButton.style.color = "#323130";
                this.SetAriaSort("none");
            }
        } catch (e) {
            ks.KGlobalErrorHandler(e, "kEditableTableHeading.SetUnsorted");
            return;
        }
    }
}
